module.exports = __webpack_public_path__ + "static/media/camera.b5656336.svg";